import { fulfilled, pending, rejected } from '../../utils';
import { ROLE } from '../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	data: [],
};

export const roleReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(ROLE):
			return {
				...state,
				loading: true,
				status: '',
			};
		case fulfilled(ROLE):
			return {
				...state,
				loading: false,
				data: action.payload.data.data.roles,
			};
		default:
			return state;
	}
};

export default roleReducer;
